<template>
    <div class="filter-criteria-container">
        <div class="filter-label">
            {{ $t('unlayerBuilder.templateSelection.filterBy') }}
        </div>

        <div class="filter-criteria">
            <DsMultiselect
                bind-value-only
                :value="filterEmailType"
                :options="typeOptions"
                :placeholder="$t('unlayerBuilder.templateSelection.savedTemplates.filterEmailTypePlaceholder')"
                class="filter-select"
                data-qa="template-email-type-filter"
                @input="handleFilterEmailTypeUpdate"
            />
        </div>
    </div>
</template>

<script>
import { AGGREGATED_EMAIL_TEMPLATES_FILTER_OPTIONS as FILTER_OPTIONS } from '@/components/broadcast/constants/emailBroadcast.constants';

export default {
    props: {
        filterEmailType: {
            type: String,
            default: FILTER_OPTIONS.ALL,
        },
    },

    computed: {
        typeOptions() {
            return [{
                value: FILTER_OPTIONS.ALL,
                label: this.$t('unlayerBuilder.templateSelection.savedTemplates.typeOptions.all'),
            }, {
                value: FILTER_OPTIONS.BARD,
                label: this.$t('unlayerBuilder.templateSelection.savedTemplates.typeOptions.legacyTemplates'),
            }, {
                value: FILTER_OPTIONS.UNLAYER,
                label: this.$t('unlayerBuilder.templateSelection.savedTemplates.typeOptions.templates'),
            }];
        },
    },

    methods: {
        handleFilterEmailTypeUpdate(value) {
            this.$emit('update:filterEmailType', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.filter-criteria-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.filter-label {
    color: $color-ink;
}

.filter-criteria {
    width: px-to-rem(300);
    margin-left: $spacing-200;
}

.filter-select {
    margin-bottom: 0;
}
</style>
